import React, { useEffect, useRef, useState } from "react";
import {
  Modal,
  Button,
  OverlayTrigger,
  Tooltip,
  ModalBody,
} from "react-bootstrap";
import "./previewImage.scss";
import { RootState } from "../../../redux/rootReducers";
import { GetGenerateSasTokenPayloadType } from "../../../commonTypes/stcoToolsType";
import {
  getTokenGenerateForDownloadAction,
  resetSasTokenForDownloadFile,
} from "../../../redux/stcoTools";
import { connect } from "react-redux";
import {
  NewWhiteDownloadIcon,
  NoFile,
  RedDeleteIcon,
  UnPreviewImage,
} from "../../../assets/images";
import PdfPreviewWithApi from "./PdfPreviewWithApi";
import { Loader, TableLoader } from "..";

interface File {
  id: string;
  name: string;
  type: string;
  url: string;
}

interface MultiFilePreviewModalProps {
  show: boolean;
  files: any;
  onClose: () => void;
  token: string | null;
  sasTokenForDownloadFile: string;
  dispatchGetTokenGenerateForDownloadAction: (
    data: GetGenerateSasTokenPayloadType
  ) => void;
  dispatchResetSasTokenForDownloadFile: () => void;
  setAllFileData: any;
  sasTokenForDownloadFetching: boolean;
  type?:string;
}

const MultiFilePreviewModal: React.FC<MultiFilePreviewModalProps> = ({
  show,
  files,
  onClose,
  token,
  sasTokenForDownloadFile,
  dispatchGetTokenGenerateForDownloadAction,
  dispatchResetSasTokenForDownloadFile,
  setAllFileData,
  sasTokenForDownloadFetching,
  type
}) => {
  const [selectedFile, setSelectedFile] = useState<any>(null);
  const [previewUrl, setPreviewUrl] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  let isAutoDownload = useRef<boolean>(false);

  useEffect(() => {
    return () => {
      dispatchResetSasTokenForDownloadFile();
    };
  }, []);

  useEffect(() => {
    if (show && files?.length > 0) {
      const firstFile = files[0];
      setSelectedFile(firstFile);
      fetchPreviewUrl(firstFile);
    }
  }, [show, files]);

  const fetchPreviewUrl = async (file: any) => {
    setLoading(true);
    try {
      let finalData = {
        token,
        fileUrl: file?.file_url,
        containerType:type==="clientDirectory"?2:1

      };
      dispatchGetTokenGenerateForDownloadAction(finalData);
    } catch (error) {
      setPreviewUrl(null);
    } finally {
      setLoading(false);
    }
  };
  // commented for future use
  // useEffect(() => {
  //   if (sasTokenForDownloadFile && isAutoDownload?.current) {
  //     const link = document.createElement("a");
  //     link.href = sasTokenForDownloadFile;
  //     link.setAttribute("download", "");
  //     link.download = selectedFile?.file_name || "downloaded_file";
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //     dispatchResetSasTokenForDownloadFile();
  //     isAutoDownload.current = false;
  //   }
  // }, [sasTokenForDownloadFile]);

  useEffect(() => {
    const downloadFile = async () => {
      if (sasTokenForDownloadFile && isAutoDownload?.current) {
        try {
          const response = await fetch(sasTokenForDownloadFile);
          if (!response.ok) {
            throw new Error(`Failed to fetch file: ${response.statusText}`);
          }
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = selectedFile?.file_name || "downloaded_file";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
          dispatchResetSasTokenForDownloadFile();
          isAutoDownload.current = false;
        } catch (error) {}
      }
    };
    downloadFile();
  }, [sasTokenForDownloadFile]);

  const handleDownload = () => {
    dispatchResetSasTokenForDownloadFile();
    let finalData = {
      token,
      fileUrl: selectedFile?.file_url,
      containerType:type==="clientDirectory"?2:1

    };
    dispatchGetTokenGenerateForDownloadAction(finalData);
    isAutoDownload.current = true;
  };

  const handleFileClick = (file: File) => {
    setSelectedFile(file);
    fetchPreviewUrl(file);
  };

  useEffect(() => {
    if (sasTokenForDownloadFile) {
      setPreviewUrl(sasTokenForDownloadFile);
    }
  }, [sasTokenForDownloadFile]);

  const handleDeleteFile = (index: string) => {
    const tempFileData = JSON.parse(JSON.stringify(files));
    const updatedFiles = [...files];
    setAllFileData(updatedFiles?.filter((e: any) => e?.file_url !== index));

    if (selectedFile?.file_url === index) {
      setSelectedFile(updatedFiles.length > 0 ? updatedFiles[0] : null);
      setPreviewUrl(null);
    }
  };
  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>View Files</Modal.Title>
      </Modal.Header>
      <ModalBody>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div className="side-bar-main-div" style={{ overflowX: "auto" }}>
            {files?.map((file: any, index: any) => (
              <div className="d-flex mb-3" key={file.id}>
                <li
                  key={file.id}
                  onClick={() => handleFileClick(file)}
                  className={`side-bar-static ${
                    selectedFile?.file_url === file?.file_url ? "active" : ""
                  }`}
                >
                  {file?.file_name?.length > 17 ? (
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 250, hide: 250 }}
                      overlay={
                        <Tooltip id="button-view-open-item">
                          {file?.file_name}
                        </Tooltip>
                      }
                    >
                      <>
                        {file?.file_name?.slice(0, 8) +
                          "..." +
                          file?.file_name?.split(".").pop()}
                      </>
                    </OverlayTrigger>
                  ) : (
                    file?.file_name
                  )}
                </li>
              </div>
            ))}
          </div>
          {files?.length > 0 && selectedFile ? (
            <div className="preview-main-div">
              <div className="preview-secondary-div">
                <p style={{ fontSize: "14px" }} className="mt-2">
                  {selectedFile?.file_name &&
                  selectedFile?.file_name?.length > 40
                    ? selectedFile?.file_name?.slice(0, 40) + "..."
                    : selectedFile?.file_name}
                </p>
                <div className="d-flex">
                  <div className="mr-2" style={{ marginTop: "5px" }}>
                    {" "}
                    <img
                      className="pointer"
                      onClick={() => handleDeleteFile?.(selectedFile?.file_url)}
                      style={{ height: "26px" }}
                      src={RedDeleteIcon}
                      alt="delete"
                    />
                  </div>
                  <div>
                    <button
                      className="btn btn-primary"
                      onClick={handleDownload}
                    >
                      <span className="pr-2">
                        <img src={NewWhiteDownloadIcon} alt="download" />
                      </span>
                      Download
                    </button>
                  </div>
                </div>
              </div>
              {sasTokenForDownloadFetching ? (
                <TableLoader Rows={10} ColumnPerRow={4} />
              ) : (
                <div>
                  {selectedFile?.file_type === "application/msword" ||
                  selectedFile?.file_type === "application/vnd.ms-excel" ||
                  selectedFile?.file_type ===
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                  selectedFile?.file_type ===
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                  selectedFile?.file_type === "application/vnd.ms-powerpoint" ||
                  selectedFile?.file_type ===
                    "application/vnd.openxmlformats-officedocument.presentationml.presentation" ? (
                    previewUrl && (
                      <iframe
                        width="100%"
                        height="350px"
                        src={`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
                          previewUrl
                        )}`}
                      />
                    )
                  ) : selectedFile?.file_type === "text/csv" ? (
                    <div className="no-preview-image-div">
                      <div style={{ width: "100%", height: "350px" }}>
                        <img
                          style={{
                            objectFit: "cover",
                            height: "100%",
                            width: "100%",
                          }}
                          src={UnPreviewImage}
                          alt="preview"
                        />
                      </div>
                    </div>
                  ) : selectedFile?.file_type === "application/pdf" ? (
                    <PdfPreviewWithApi imageDetails={previewUrl} />
                  ) : (
                    <img
                      style={{
                        width: "100%",
                        height: "50%",
                      }}
                      src={previewUrl}
                      alt="url"
                    />
                  )}
                </div>
              )}
            </div>
          ) : (
            <div style={{ height: "400px", margin: "auto" }}>
              <div className=" mt-5">
                <img
                  src={NoFile}
                  alt="no-file"
                  style={{ width: "200px", marginRight: "202px" }}
                  className="mb-5"
                />
                <h1 style={{ textAlign: "center", marginRight: "202px" }}>
                  No files
                </h1>

                <span className="sub-text"></span>
              </div>
            </div>
          )}
        </div>
      </ModalBody>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const mapStateToProps = (state: RootState) => ({
  sasTokenForDownloadFile: state.stcoTools.sasTokenForDownloadFile,
  sasTokenForDownloadFetching: state.stcoTools.sasTokenForDownloadFetching,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetTokenGenerateForDownloadAction: (
    data: GetGenerateSasTokenPayloadType
  ) => dispatch(getTokenGenerateForDownloadAction(data)),
  dispatchResetSasTokenForDownloadFile: () =>
    dispatch(resetSasTokenForDownloadFile()),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MultiFilePreviewModal);
